import { useIdentity } from '@vp/ubik-context'
import { useDispatch } from 'react-redux'
import { setAuthData } from 'client/store/auth/actions'
import { useEffect } from 'react'

export const useUpdateAuthData = (): void => {
  const dispatch = useDispatch()
  const { auth, identity } = useIdentity()
  useEffect(() => {
    dispatch(setAuthData({ canonicalId: auth?.getCanonicalId(), accessToken: identity?.accessToken }))
  }, [auth, dispatch, identity, setAuthData])
}
